import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { VhImage, VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
// import { FunctionService } from 'vhobjects-service';
// import { ManageLibraryComponent } from '../../../.././manage-library/manage-library.component';
import { FunctionService } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { ChooseIconComponent, ChooseImageComponent, ManageLibraryComponent } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { LanguageService } from 'vhobjects-service';
import { ThemeService } from 'vhobjects-service';

interface TabBarNavItem {
  label: string;
  type: string;
  icon?: string;
  image?: string;
  link?: string;
  active?: boolean;
  __pendingImageFile?: File;
}
@Component({
  selector: 'atw-tab-bar-admin-config',
  templateUrl: './tab-bar-admin-config.component.html',
  styleUrls: ['./tab-bar-admin-config.component.scss']
})
export class AtwTabBarAdminConfig extends AtwUpdateDbComponent implements OnInit {
  isCollapsed: boolean = false;
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false; // biến kiểm tra khi đang xử lý dữ liệu
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() type: any; // xem đang ở page hay admin
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() blocks_of_page?: any; // lấy dữ liệu blocks_of_page trên page
  effect_hover = [];
  isApplyShadow: boolean = false; // Cho phép thêm | chỉnh sửa bóng
  effect_hover_data: any = {};
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  previewUploadUrl: string | null = null; // url preview trong vùng kéo thả
  pendingObjectImageFile: File | null = null;
  dragging = false; // biến kiểm tra người dùng dùng rời con trỏ khỏi vùng upload mà chưa thả
  navItemImageModalVisible: boolean = false;
  navItemImageSource: string = 'device';
  navItemImagePreviewUrl: string | null = null;
  navItemImageFile: File | null = null;
  navItemEditing: TabBarNavItem | null = null;
  navItemImageSaving: boolean = false;
  customize = [];
  backgroundColor: any = [];
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
    {
      title: 'nen_bieu_tuong',
      index: 5,
    },
  ];
  /** Có nên mở nút cập nhật kích thước ảnh cho bằng kích thước thiết kế hay không */
  isDesignImageSizeValid: boolean = true;
  id_subproject: any;
  imageDeviceWidthMax: string = 'desktop'; // biến này để lưu thiết bị có hình ảnh width lớn nhất
  widthImageMax: number = 0;
  heightImageMax: number = 0;
  subProject = null;
  resolution = null;
  width: number = 0;
  height: number = 0;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    private dialog: MatDialog,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private languageService: LanguageService,
    private vhImage: VhImage,
    public themeService: ThemeService,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  async ngOnInit(): Promise<void> {
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;

    this.subProject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );
    this.resolution = this.subProject.resolution;


    // Kiểm tra nếu chưa có config thì thêm để người dùng không cần xóa thêm lại
    if (!this.config.hasOwnProperty('position_onscroll')) {
      this.config.position_onscroll = {
        type: 0,
        top: 0,
      };
    }

    const index = this.staticdata.nav_item?.findIndex(item => item.active);
    this.activeIndex = index !== -1 ? index : 0;

    this.getLinkAllPages();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.width = document.getElementById(this.objectChoosing._id).clientWidth;
        this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      }
    }, 0);
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }

  /**
 * Cập nhật Setups vào database.
 */
  updateSetups() {

    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { setups: this.objectChoosing.setups })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }

  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    });
  }
  /**
   * Hàm update object vào database.
   */
  updateFields(value) {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, value)
      .then((bool: any) => { });
  }
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => { });
  }
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean; } = {
    menu1: false,
    menu2: true,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  openMapSub: { [name: string]: boolean; } = { menu1: true, menu2: false };
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    console.log(event)
    if (event.width) this.class['image']['width'] = event.width + 'px';
    if (event.height) this.class['image']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }


  updateClassAndConfig() {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }

  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[2])
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['tab-bar']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['tab-bar']['background-image'] = "none";
    }
    this.updateObject();
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        // console.log('updateObject', bool);
      })
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient = this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /** Hàm này cho phép chọn options direction của màu gradient
     * @param direction : trả về hướng phối màu được chọn
     * @param event : trả về element được active
     */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['tab-bar']['background-image'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  /**Hàm này dùng để click chọn màu nền của danh sách màu.
     * @param bgColor : trả về màu được chọn
     * @param event : trả về element được active
     */
  chooseBg(bgColor, event, classBg) {
    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector(
        '.container-color .active'
      ) as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      const data_background = this.class[classBg]
      data_background['background-color'] = bgColor.bgColor;
      data_background['background-color'] = `rgba(${this.hexToRGB(data_background['background-color'])}, ${this.config['background-color'].value_range})`;
      this.updateObject();
    }
  }

  visibleAdd = false;

  openDialogChooseIcon(item: any) {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        item.icon = result.icon;
        // this.updateConfig();
      }
    });
  }

  openDialogChooseImage(item: TabBarNavItem) {
    this.navItemEditing = item;
    this.navItemImageSource = item?.__pendingImageFile ? 'device' : 'url';
    this.navItemImagePreviewUrl = item?.image || null;
    this.navItemImageFile = item?.__pendingImageFile || null;
    this.dragging = false;
    this.navItemImageModalVisible = true;
  }

  activeIndex = 0;

  onActiveChange(index: number) {
    this.staticdata.nav_item.forEach((item: TabBarNavItem, i: number) => {
      item.active = i === index;
    });
  }

  addTab() {
    const list: TabBarNavItem[] = this.staticdata.nav_item ? [...this.staticdata.nav_item] : [];

    const newItem = {
      label: `Tab ${list.length + 1}`,
      type: 'icon',
      icon: 'home',
      image: '',
      active: true,
    };

    list.push(newItem);

    this.staticdata.nav_item = list;

    this.activeIndex = list.length - 1;
  }

  removeTab(index: number) {
    if (!this.staticdata.nav_item) return;

    this.staticdata.nav_item.splice(index, 1);

    // Fix activeIndex after delete
    if (this.activeIndex === index) {
      // If deleted current → reset
      this.activeIndex = this.staticdata.nav_item.length ? 0 : -1;
    } else if (this.activeIndex > index) {
      // Shift left if needed
      this.activeIndex--;
    }

    this.staticdata.nav_item = [...this.staticdata.nav_item];
  }

  listPage = [];

  /**
   * Xử lý lấy link các page về.
   */
  getLinkAllPages() {
    this.vhQueryAutoWeb.getPages_byFields({}).then((pages: any) => {
      // Dùng cho trường hợp trang không có name_vn (Hoặc functionService.selectedLanguageCode)
      const pagesNew = pages.map((page) => {
        // if (!page.name) console.warn('Không có name', page)
        if (!page['name_' + this.functionService.selectedLanguageCode] && page.name) {
          return {
            ...page,
            ['name_' + this.functionService.selectedLanguageCode]: page.name
          };
        } else return page;
      });
      this.listPage = pagesNew;
    });
  }

  async saveTab() {
    const navItems: TabBarNavItem[] = this.staticdata.nav_item || [];
    const itemsNeedUpload = navItems.filter((item) => item.__pendingImageFile);

    if (itemsNeedUpload.length) {
      this.isConfirmLoading = true;

      try {
        for (const item of itemsNeedUpload) {
          const pendingFile = item.__pendingImageFile;
          if (!pendingFile) {
            continue;
          }

          const imageUrl = await this.uploadImageFileToServer(pendingFile);
          item.image = imageUrl;
          delete item.__pendingImageFile;
        }
      } catch (error) {
        this.isConfirmLoading = false;
        return;
      }
    }

    this.updateStaticData();
    this.visibleAdd = false;
    this.isConfirmLoading = false;
  }

  closeNavItemImageModal() {
    this.navItemImageModalVisible = false;
    this.navItemEditing = null;
    this.navItemImageFile = null;
    this.navItemImagePreviewUrl = null;
    this.navItemImageSaving = false;
    this.dragging = false;
  }

  openNavItemUpload() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('navItemUpload')?.click();
    }
  }

  onNavItemImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.functionService.createMessage('warning', 'vui_long_chon_tep_hinh_anh_hop_le');
      input.value = '';
      return;
    }

    this.setNavItemImageFile(file);
    input.value = '';
  }

  onNavItemFileDropped(event: DragEvent) {
    event.preventDefault();
    this.dragging = false;
    const file = event.dataTransfer?.files?.[0];

    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.functionService.createMessage('warning', 'vui_long_keo_tep_hinh_anh_hop_le');
      return;
    }

    this.setNavItemImageFile(file);
  }

  onNavItemImageSourceChange(source: string) {
    this.navItemImageSource = source;

    if (source === 'device') {
      return;
    }

    this.navItemImageFile = null;
    if (this.navItemEditing?.__pendingImageFile) {
      delete this.navItemEditing.__pendingImageFile;
    }
  }

  canSaveNavItemImage(): boolean {
    if (this.navItemImageSource === 'url') {
      return !!this.navItemImagePreviewUrl?.trim();
    }

    return !!this.navItemImageFile;
  }

  private setNavItemImageFile(file: File) {
    this.navItemImageFile = file;
    const reader = new FileReader();
    reader.onload = () => {
      this.navItemImagePreviewUrl = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  async saveNavItemImage() {
    if (!this.navItemEditing || !this.canSaveNavItemImage()) {
      this.functionService.createMessage('warning', 'vui_long_chon_tep_hinh_anh_hop_le');
      return;
    }

    this.navItemImageSaving = true;

    this.navItemEditing.image = this.navItemImagePreviewUrl?.trim() || this.navItemEditing.image;

    if (this.navItemImageSource === 'device' && this.navItemImageFile) {
      this.navItemEditing.__pendingImageFile = this.navItemImageFile;
    } else {
      delete this.navItemEditing.__pendingImageFile;
    }

    this.closeNavItemImageModal();
  }

  private uploadImageFileToServer(file: File): Promise<string> {
    const method = this.navItemImageSource === 'device' ? 'getImageFromDesktop_Autoweb' : 'getImageFromURL_Autoweb';
    return this.vhImage[method](file, 'images/design/objects', {
      compress_type: 'no-compress',
      resolution: {
        width: parseInt(this.class['tab-bar__img']['width']) || 0,
        height: parseInt(this.class['tab-bar__img']['height']) || 0,
      },
    })
      .then((res: any) => {
        // console.log('res', res);
        if (res.vcode != 0) {
          this.functionService.createMessage(
            'error',
            `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${res.msg}`
          );
          throw new Error(res.msg);
        }
        return res.data;
      }).catch(() => {
        console.error('Lỗi khi tải ảnh lên server');
      });
  }

  /**
   * Hàm xử lý khi người dùng kéo và thả (drop) một tệp vào vùng upload.
   * @param event
   */
  onObjectImageDropped(event: DragEvent, type = 'img') {
    event.preventDefault();
    this.dragging = false;
    const file = event.dataTransfer?.files[0];

    if (file && file.type.startsWith('image/')) {
      // Hiển thị preview
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUploadUrl = reader.result as string;
      };
      reader.readAsDataURL(file);

      // Chỉ lưu tạm file để người dùng tự quyết định khi nào upload
      this.pendingObjectImageFile = file;
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_keo_tep_hinh_anh_hop_le');
        return;
      }
    }
  }

  /**
  * Hành động khi người dùng kéo file qua vùng upload (chưa thả).
  * @param event
  */
  onDragOver_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = true;
  }

  /**
   * Hành động khi người dùng rời con trỏ khỏi vùng upload mà chưa thả.
   */
  onDragLeave_upload() {
    this.dragging = false;
  }

}
